/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonResumeeReprocessGrade202,
  PostApiV1PersonResumeeReprocessGrade400,
  PostApiV1PersonResumeeReprocessGrade401,
  PostApiV1PersonResumeeReprocessGrade500,
  PostApiV1PersonResumeeReprocessGradeMutationRequest,
  PostApiV1PersonResumeeReprocessGradeMutationResponse,
} from "../../types/personResumeeController/PostApiV1PersonResumeeReprocessGrade.ts";
import { reprocessGradePersonOnlyViewModelSchema } from "../reprocessGradePersonOnlyViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonResumeeReprocessGrade202Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGrade202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonResumeeReprocessGrade400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGrade400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonResumeeReprocessGrade401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGrade401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonResumeeReprocessGrade500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonResumeeReprocessGrade500>;

export const postApiV1PersonResumeeReprocessGradeMutationRequestSchema = z.lazy(
  () => reprocessGradePersonOnlyViewModelSchema,
) as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeMutationRequest>;

export const postApiV1PersonResumeeReprocessGradeMutationResponseSchema =
  z.lazy(
    () => postApiV1PersonResumeeReprocessGrade202Schema,
  ) as unknown as ToZod<PostApiV1PersonResumeeReprocessGradeMutationResponse>;
